import Script from 'next/script'
import { useHits } from 'react-instantsearch'

interface ListProps {
  basePath: string
}

function List({ basePath }: ListProps) {
  const { items } = useHits()
  return (
    <>
      {items.map(
        ({
          eventCreatedAtTimestamp,
          editionLiveStartDateTimestamp,
          editionLiveEndDateTimestamp,
          eventCoverImage,
          eventName,
          eventCity,
          eventSlug,
          eventLivePriceStartingFrom,
          objectID
        }) => {
          const startDate = new Date(
            editionLiveStartDateTimestamp * 1000
          ).toISOString()
          const endDate = new Date(
            editionLiveEndDateTimestamp * 1000
          ).toISOString()
          const createdAt = eventCreatedAtTimestamp
            ? new Date(eventCreatedAtTimestamp * 1000).toISOString()
            : null

          const idJsonObject = {
            '@context': 'https://schema.org',
            '@type': 'Event',
            name: eventName,
            startDate: startDate,
            endDate: endDate,
            eventAttendanceMode:
              'https://schema.org/OfflineEventAttendanceMode',
            eventStatus: 'https://schema.org/EventScheduled',
            location: {
              '@type': 'Place',
              name: 'Snickerpark Stadium',
              address: {
                '@type': 'PostalAddress',
                addressLocality: eventCity
              }
            },
            image: [eventCoverImage],
            offers: {
              '@type': 'Offer',
              url: `${basePath}/event/${eventSlug}`,
              ...(eventLivePriceStartingFrom && {
                price: eventLivePriceStartingFrom,
                priceCurrency: 'EUR'
              }),
              availability: 'https://schema.org/InStock',
              validFrom: createdAt || startDate,
              priceValidUntil: endDate
            }
          }

          return (
            <Script
              key={objectID}
              id={objectID}
              strategy="beforeInteractive"
              type="application/ld+json"
              dangerouslySetInnerHTML={{ __html: JSON.stringify(idJsonObject) }}
            />
          )
        }
      )}
    </>
  )
}

export default List
